module.exports = __webpack_public_path__ + "static/media/handshake.91a71ee4.png";